import { providerState, sessionState } from "@/state"

export default {
    getHomeLocation() {
        return {
            path: "/home/:flowType/:experienceType",
            params: {
                experienceType: sessionState.experienceType,
                flowType: sessionState.flowType,
            },
        }
    },

    getProviderStartLocation(providerKey, applyMode) {
        if (sessionState.flowType && sessionState.flowType !== "apply") {
            return `/providers/${providerKey}/${sessionState.flowType}/start`
        }

        let loc

        if (providerState.primaryProvider?.providerKey === providerKey) {
            const hasProveEnabled = sessionState.session.extensions.some(ext => ext.featureId === "prove")
            const initialRoute = hasProveEnabled ? "prove" : "start"
            loc = `/providers/${providerKey}/modes/${applyMode}/primary/${initialRoute}`
        } else {
            loc = `/providers/${providerKey}/modes/${applyMode}/start`
        }

        return loc
    },

    getRedirectLocation(to) {
        return {
            name: "redirect",
            params: { to },
        }
    },
}
